<template>
      <div class="profile d-flex flex-column vh-100">
       <header class="modern-header" role="banner">
              <div class="header-content">
                <button class="back-btn" @click="goBack" aria-label="Go back">
                  <i class="bi bi-arrow-left" aria-hidden="true"></i>
                </button>
                <div class="header-text ">
                  <h1 class="course-title">Accounting </h1>
                  <p class="course-subtitle">All Transactions Information</p>
                </div>
              </div>
            </header>

         
        

        <div class="vh-100 my-auto overflow-auto p-3 main-content">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                 <th scope="col">Entry Date</th>
                                <th scope="col">Course Name</th>
                                <th scope="col">Total</th>
                                <th scope="col">Paid</th> 
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in getaccoutinginfo" :key="index">
                                <th scope="row">{{ index + 1 }}</th>
                                 <td>{{ item.iddate }}</td>
                                <td>{{ item.course_name }}</td>
                                <td>{{ item.total }}</td>
                                <td>{{ item.paid }}</td>
                            </tr>
                        </tbody>
                         <tfoot>
                                <tr>
                                    <th colspan="3">Total</th>
                                    <td>{{ totalSum }}</td>
                                    <td>{{ paidSum }}</td>
                                </tr>
                                </tfoot>
                    </table>
                </div>
             










         
      </div>




   </template>
   <style>

   .main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem 6rem;
}

   
.modern-header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(26, 26, 46, 0.95);
  padding: 10px;
}

.back-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.course-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.course-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin: 0;
}
   .logout-footer {
   position: fixed;       /* fixed to screen */
   bottom: 0;             /* always at bottom */
   left: 0;
   width: 100%;           /* full width */
   background: #f8f9fa;   /* light background to separate from content */
   padding: 10px 15px;
   z-index: 1000;         /* above other content */
}
   </style>
   <script> 
      import axios from "@/plugins/axios";  
      
      export default {
        name: 'Branch',
        components: { 
        },
        mounted() { 
         //  this.fetchWeather();
          this.getProfile(); // Call the method here
          
      },
       computed: {
    totalSum() {
      return this.getaccoutinginfo.reduce((sum, item) => sum + Number(item.total), 0);
    },
    paidSum() {
      return this.getaccoutinginfo.reduce((sum, item) => sum + Number(item.paid), 0);
    }
  },
        data() {
          return { 
           
            loading:false,
            error:null,
            isUserLogged:false,
            getaccoutinginfo:[],

      
         }
        },
        methods:{
          initializeHomeContent(){
          
      
          },

       

          goBack() {
                
                this.$router.go(-1);
        },
     
   
     

          async getProfile() {
              this.loading = true;
              this.error = null;
        
              try {
                 var self=this;
                  axios.post("getaccountingdeatils").then((response) => {
                     self.getaccoutinginfo=response.data.getaccoutinginfo;
                
              
                }).then(() => {
                     self.initializeHomeContent();
                }).catch((err) => {
                  
                });;
               
      
              } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
              } finally {
                this.loading = false;
              }
            }, 
            
      
      
        }
      }
      
      
      
      
      
      
      </script>